import { useState, useCallback } from 'react';
import { validatePlaylistName, validatePlaylistDescription } from '../utils/playlistValidation';

export const usePlaylistValidation = () => {
    const [nameError, setNameError] = useState<string | null>(null);
    const [descriptionError, setDescriptionError] = useState<string | null>(null);

    const validateName = useCallback((name: string): boolean => {
        const error = validatePlaylistName(name);
        setNameError(error);
        return error === null;
    }, []);

    const validateDescription = useCallback((description: string): boolean => {
        const error = validatePlaylistDescription(description);
        setDescriptionError(error);
        return error === null;
    }, []);

    const validateAll = useCallback((name: string, description: string): boolean => {
        const nameValid = validateName(name);
        const descriptionValid = validateDescription(description);
        return nameValid && descriptionValid;
    }, [validateName, validateDescription]);

    const clearErrors = useCallback(() => {
        setNameError(null);
        setDescriptionError(null);
    }, []);

    return {
        nameError,
        descriptionError,
        validateName,
        validateDescription,
        validateAll,
        clearErrors
    };
}; 